import { UserProps, UserStatus } from "./types";

export const DUMMY_DATA: Array<UserProps> = [
  {
    _id: { $oid: "666" },
    access_list: ["AddEditCustomer"],
    fullname: "علی احمدی",
    pic: require("../../../assets/images/profile.jpg"),
    role: "مدیر فروش",
    status: UserStatus.Online,
    updates: [
      {
        date: Date.now(),
        by: { id: { $oid: "517" }, fullname: "surrender" },
        access_diff: {
          del: ["ConfirmCheque", "EditFactorCheque"],
          new: ["ReceiveCash", "SpendCash"],
        },
      },
      {
        date: Date.now(),
        by: { id: { $oid: "517" }, fullname: "surrender" },
        access_diff: {
          del: ["ConfirmCheque", "EditFactorCheque"],
          new: ["AddEditCustomer", "ReceiveCash", "SpendCash"],
        },
      },
      {
        date: Date.now(),
        by: { id: { $oid: "517" }, fullname: "surrender" },
        access_diff: {
          del: ["ConfirmCheque", "EditFactorCheque"],
          new: ["AddEditCustomer", "ReceiveCash", "SpendCash"],
        },
      },
      {
        date: Date.now(),
        by: { id: { $oid: "517" }, fullname: "surrender" },
        access_diff: {
          del: ["ConfirmCheque", "EditFactorCheque"],
          new: ["AddEditCustomer", "ReceiveCash", "SpendCash"],
        },
      },
      {
        date: Date.now(),
        by: { id: { $oid: "517" }, fullname: "surrender" },
        access_diff: {
          del: ["ConfirmCheque", "EditFactorCheque"],
          new: ["AddEditCustomer", "ReceiveCash", "SpendCash"],
        },
      },
    ],
    username: "ricky",
  },
  {
    _id: { $oid: "666" },
    access_list: [],
    fullname: "علی احمدی",
    pic: require("../../../assets/images/profile.jpg"),
    role: "مدیر فروش",
    status: UserStatus.Offline,
    updates: [],
    username: "ricky",
  },
  {
    _id: { $oid: "666" },
    access_list: [],
    fullname: "علی احمدی",
    pic: require("../../../assets/images/profile.jpg"),
    role: "مدیر فروش",
    status: UserStatus.Offline,
    updates: [],
    username: "ricky",
  },
  {
    _id: { $oid: "666" },
    access_list: [],
    fullname: "علی احمدی",
    pic: require("../../../assets/images/profile.jpg"),
    role: "مدیر فروش",
    status: UserStatus.Online,
    updates: [],
    username: "ricky",
  },
  {
    _id: { $oid: "666" },
    access_list: [],
    fullname: "علی احمدی",
    pic: require("../../../assets/images/profile.jpg"),
    role: "مدیر فروش",
    status: UserStatus.Offline,
    updates: [],
    username: "ricky",
  },
  {
    _id: { $oid: "666" },
    access_list: [],
    fullname: "علی احمدی",
    pic: require("../../../assets/images/profile.jpg"),
    role: "مدیر فروش",
    status: UserStatus.Online,
    updates: [],
    username: "ricky",
  },
  {
    _id: { $oid: "666" },
    access_list: [],
    fullname: "علی احمدی",
    pic: require("../../../assets/images/profile.jpg"),
    role: "مدیر فروش",
    status: UserStatus.Offline,
    updates: [],
    username: "ricky",
  },
  {
    _id: { $oid: "666" },
    access_list: [],
    fullname: "علی احمدی",
    pic: require("../../../assets/images/profile.jpg"),
    role: "مدیر فروش",
    status: UserStatus.Offline,
    updates: [],
    username: "ricky",
  },
  {
    _id: { $oid: "666" },
    access_list: [],
    fullname: "علی احمدی",
    pic: require("../../../assets/images/profile.jpg"),
    role: "مدیر فروش",
    status: UserStatus.Online,
    updates: [],
    username: "ricky",
  },
  {
    _id: { $oid: "666" },
    access_list: [],
    fullname: "علی احمدی",
    pic: require("../../../assets/images/profile.jpg"),
    role: "مدیر فروش",
    status: UserStatus.Offline,
    updates: [],
    username: "ricky",
  },
];
